import moment from 'moment';
import {
  FETCH_RECORDS_REQUEST,
  FETCH_RECORDS_SUCCESS,
  FETCH_RECORDS_FAILURE,
  CHANGE_PAGE,
  FETCH_RECORDS_COUNT_SUCCESS,
  CHANGE_TAB,
  SET_FILTER,
  SET_FILTER_ERROR,
  RESET_FILTERS,
  INIT_SEARCH_PAGE,
  SEARCH_ALREADY_INIT,
  RESET_COUNT_CURRENTPAGE_PAGECOUNT,
  SET_FILTER_SUPERVISOR,
  SET_SORT,
  FETCH_USER_FEEDS,
  CHANGE_POS,
} from './constants';
import { RECORD_STATUS, NRM_SUB_STATUS, decodeVinCountry } from '../../../config';
import { RecordMapper } from '../../../config/Record/RecordMapper';

const {
  expertise_restarted,
  expertise_started,
  expertise_finished,
  expertise_authorized,
  supervisor_refused,
  refused,
  expertise_interrupted,
  waiting_for_counter_appraisal,
  counter_appraisal_verification,
} = RECORD_STATUS;
const {
  pricingInProgress,
  tradeInPriceProposed,
  noTradeInPriceProposed,
  tradeInLinkedToNcNotConfirmedByClient,
  tradeInExpired,
  tradeInConfirmedByClient,
  tradeInWithOrderId,
  tradeInCancelled,
  waitingForCounterAppraisal,
  counterAppraisalVerification,
  tradeInMaintainedPriceMaintained,
  tradeInMaintainedPriceModified,
} = NRM_SUB_STATUS;

const entryStockDateMin = moment().format('YYYY-MM-DD');
const entryStockDateMax = moment().add(15, 'days').format('YYYY-MM-DD');
export const buyerTabs = {
  buyerOnGoing: {},
  buyerAwaitingPricing: { status: [expertise_finished] },
  buyerAwaitingReturn: { status: [expertise_authorized] },
  buyerAwaitingForCounterAppraisal: { status: [waiting_for_counter_appraisal] },
  buyerOutdated: { status: [supervisor_refused, refused, expertise_interrupted] },
};

export const supervisorTabs = {
  supervisorAwaiting: { status: [expertise_finished], recordTypeId: 1 },
  supervisorOngoingAppraisal: { status: [expertise_restarted, expertise_started] },
  supervisorCoverageRequest: {},
  supervisorCounterAppraisalVerification: { status: [counter_appraisal_verification] },
};

export const nrmTabs = {
  onGoingNrm: { status: [expertise_restarted, expertise_started] },
  pricingInProgressNrm: { nrmStatus: [pricingInProgress] },
  guaranteeActivatedNrm: {
    nrmStatus: [
      tradeInPriceProposed,
      tradeInLinkedToNcNotConfirmedByClient,
      tradeInConfirmedByClient,
      tradeInWithOrderId,
    ],
  },
  waitingCounterInspectionNrm: {
    nrmStatus: [waitingForCounterAppraisal, counterAppraisalVerification],
  },
  finalizedNrm: { nrmStatus: [tradeInMaintainedPriceMaintained, tradeInMaintainedPriceModified], recordTypeId: 1 },
  abandonedNrm: { nrmStatus: [tradeInCancelled, noTradeInPriceProposed, tradeInExpired] },
};

const calculateRange = (page, recordsPerPage) => {
  const startRange = recordsPerPage * (page - 1);
  return [startRange, startRange + recordsPerPage - 1];
};

const defaultUpdateAtMin = () => moment().subtract(7, 'days').format('YYYY-MM-DD');

const fetchRecordListRequest = () => ({
  type: FETCH_RECORDS_REQUEST,
});

const fetchRecordListSuccess = ({ records, type, count }) => ({
  type: FETCH_RECORDS_SUCCESS,
  payload: { records, type, count },
});

const fetchRecordListCountSuccess = (counts) => ({
  type: FETCH_RECORDS_COUNT_SUCCESS,
  payload: counts,
});

const fetchRecordListFailure = (error) => ({
  type: FETCH_RECORDS_FAILURE,
  payload: error,
});

const goTopage = (page) => ({
  type: CHANGE_PAGE,
  payload: { page },
});

const displayTab = (tab) => ({
  type: CHANGE_TAB,
  payload: { tab },
});

const resetCountCurrentPage = () => ({
  type: RESET_COUNT_CURRENTPAGE_PAGECOUNT,
});

const initSearchPage = (state) => {
  if (state.recordList.currentTab !== 'search') {
    return {
      type: INIT_SEARCH_PAGE,
    };
  }

  return { type: SEARCH_ALREADY_INIT };
};

const setFilter = (filterName, filterValue) => ({
  type: SET_FILTER,
  payload: { name: filterName, value: filterValue },
});

const setFilterError = (filterName, filterValue) => ({
  type: SET_FILTER_ERROR,
  payload: { name: filterName, value: filterValue },
});

const setFilterDate = (filterName, filterValue, state) => {
  const creationDateMinState = state.recordList.filters.creationDateMin.value;
  const creationDateMaxState = state.recordList.filters.creationDateMax.value;
  const entryStockDateMinState = state.recordList.filters.entryStockDateMin?.value;
  const entryStockDateMaxState = state.recordList.filters.entryStockDateMax?.value;
  switch (filterName) {
    case 'creationDateMax': {
      if (creationDateMinState) {
        if (moment(creationDateMinState).isSameOrBefore(moment(filterValue))) {
          return setFilter(filterName, filterValue);
        }
        return setFilterError(filterName, 'maxDateShouldBeGreaterThanMinDate');
      }
      return setFilter(filterName, filterValue);
    }
    case 'creationDateMin': {
      if (creationDateMaxState) {
        if (moment(creationDateMaxState).isSameOrAfter(moment(filterValue))) {
          return setFilter(filterName, filterValue);
        }
        return setFilterError(filterName, 'minDateShouldBeSmallerThanMaxDate');
      }
      return setFilter(filterName, filterValue);
    }
    case 'entryStockDateMax': {
      if (entryStockDateMinState) {
        if (moment(entryStockDateMinState).isSameOrBefore(moment(filterValue))) {
          return setFilter(filterName, filterValue);
        }
        return setFilterError(filterName, 'maxDateShouldBeGreaterThanMinDate');
      }
      return setFilter(filterName, filterValue);
    }
    case 'entryStockDateMin': {
      if (entryStockDateMaxState) {
        if (moment(entryStockDateMaxState).isSameOrAfter(moment(filterValue))) {
          return setFilter(filterName, filterValue);
        }
        return setFilterError(filterName, 'minDateShouldBeSmallerThanMaxDate');
      }
      return setFilter(filterName, filterValue);
    }
    default: {
      return setFilter(filterName, filterValue);
    }
  }
};

const setFilterSupervisor = (filters) => ({
  type: SET_FILTER_SUPERVISOR,
  payload: { filters },
});

function getRange(state) {
  const { recordPerPage } = state.recordList;
  const page = state.recordList.currentPage;
  return calculateRange(page, recordPerPage);
}

function getFilters(state) {
  const { filters } = state.recordList;
  return filters;
}

function getFiltersSupervisor(state) {
  const { filtersSupervisor } = state.recordList;
  return filtersSupervisor;
}

function getFiltersNrm(state) {
  const { filtersSupervisor } = state.recordList;
  return filtersSupervisor;
}
function getTab(state) {
  return state.recordList.currentTab;
}

function getSort(state) {
  const { sort } = state.recordList;
  return sort;
}

function getSelectedPos(state) {
  const { selectedPos } = state.recordList;
  return selectedPos;
}

const resetFilters = () => ({
  type: RESET_FILTERS,
});

const setSort = (sort) => ({
  type: SET_SORT,
  payload: { sort },
});

const fetchUserFeeds = (userFeedTotals) => ({
  type: FETCH_USER_FEEDS,
  payload: userFeedTotals,
});

const changePos = (pos) => ({
  type: CHANGE_POS,
  payload: { pos },
});

export class RecordListActions {
  constructor({ recordManager, auth, syncManager }) {
    this.syncManager = syncManager;
    this.recordManager = recordManager;
    this.auth = auth;
  }

  resetCountCurrentPage = () => async (dispatch) => {
    dispatch(resetCountCurrentPage());
  };

  initSearchPage = () => async (dispatch, getState) => {
    dispatch(initSearchPage(getState()));
  };

  setFilter = (name, value) => async (dispatch) => {
    dispatch(setFilter(name, value));
  };

  setFilterDate = (name, value) => async (dispatch, getState) => {
    dispatch(setFilterDate(name, value, getState()));
  };

  searchWithFilters = () => async (dispatch, getState) => {
    dispatch(fetchRecordListRequest());
    const state = getState();
    let filters = getFilters(state);
    filters = Object.entries(filters);
    const range = getRange(state);
    let sort = getSort(state);
    const params = {};
    params.publicPos = false;
    if (this.auth.notAllowedToSeeAllConcessionsFiles()) {
      params.userId = this.auth.userId();
    }
    if (this.auth.isNrmUser()) {
      const mode = decodeVinCountry.includes(this.auth.country()) ? 'vin' : 'registration';
      if (getSelectedPos(state) === 'publicPos') {
        params.publicPos = true;
        filters = filters.filter(([key]) => ['refHexaId', 'nrmRecordId', mode].includes(key));
      }
    }

    filters.forEach(([key, value]) => {
      if (value.value !== null && value.value !== '' && !Number.isNaN(value.value)) params[key] = value.value;
    });
    try {
      if (sort?.[0] === 'coverageDate') sort = [];
      if (this.auth.isOnlyNrmUser()) params.mode = 'nrm';
      if (params?.nrmStatus?.join('') === '0') {
        params.recordStatus = [expertise_restarted, expertise_started];
        params.mode = 'nrm';
        delete params?.nrmStatus;
      }
      const { records, totalCount } = await this.recordManager.search({ ...params, range, sort });
      const datas = records.map((r) => RecordMapper.mapRecordLists(r));
      dispatch(fetchRecordListSuccess({ records: datas, count: totalCount, type: 'search' }));
    } catch (error) {
      dispatch(fetchRecordListFailure(error.message));
    }
  };

  setFilterSupervisor = (filters) => async (dispatch) => {
    await dispatch(setFilterSupervisor(filters));
  };

  resetFilters = () => async (dispatch) => {
    dispatch(resetFilters());
  };

  goTopage = (page) => async (dispatch) => {
    dispatch(goTopage(page));
  };

  displayTab = (tab) => async (dispatch) => {
    dispatch(goTopage(1));
    dispatch(displayTab(tab));
  };

  fetchSupervisorRecordForCurrentTab = () => async (dispatch, getState) => {
    const state = getState();
    let tab = getTab(state);
    const availableTabs = Object.keys(supervisorTabs);
    if (!availableTabs.includes(tab)) {
      [tab] = availableTabs;
      dispatch(displayTab(tab));
    }
    const range = getRange(state);
    dispatch(fetchRecordListRequest());
    const { status, recordTypeId } = supervisorTabs[tab];
    const filters = getFiltersSupervisor(state);
    const params = { ...filters, status, recordTypeId };
    let sort = getSort(state);
    if (sort?.[0] === 'coverageDate' && tab !== 'supervisorCoverageRequest') sort = [];
    if (tab === 'supervisorAwaiting' && (sort.length === 0 || sort[0] === 'coverageDate'))
      sort = ['expertiseEndedAt', 'ASC'];
    try {
      let result = { records: [], totalCount: 0 };
      let datas = [];
      if (tab === 'supervisorCoverageRequest') {
        result = await this.recordManager.searchSupervisorCoverageRequest({
          sale_offer_type: 'cover',
          coverageDate: defaultUpdateAtMin(),
          range,
          sort: (sort[0] === 'coverageDate' && sort) || [],
        });
        const now = new Date();
        datas = result?.records
          .map((r) => RecordMapper.mapCoverageRequestDetail(r))
          .filter((r) => r.salesEndedAt && new Date(r.salesEndedAt) > new Date(now - 7 * 24 * 60 * 60 * 1000))
          .sort((a, b) => new Date(a.salesEndedAt) - new Date(b.salesEndedAt));
      } else {
        result = await this.recordManager.search({
          ...params,
          updatedAtMin: defaultUpdateAtMin(),
          range,
          sort,
          mode: 'full',
        });
        datas = result?.records.map((r) => RecordMapper.mapRecordLists(r));
      }
      const { totalCount } = result;
      dispatch(fetchRecordListSuccess({ records: datas, count: totalCount, type: tab }));
    } catch (error) {
      dispatch(fetchRecordListFailure(error.message));
    }
  };

  refreshSupervisorRecordsCount = () => async (dispatch, getState) => {
    dispatch(fetchRecordListRequest());
    try {
      const counts = {};
      const state = getState();
      const filters = getFiltersSupervisor(state);
      const sort = getSort(state);
      await Promise.all(
        Object.entries(supervisorTabs).map(async ([type, { status, recordTypeId }]) => {
          if (type === 'supervisorCoverageRequest') {
            const { totalCount } = await this.recordManager.searchSupervisorCoverageRequest({
              sale_offer_type: 'cover',
              coverageDate: defaultUpdateAtMin(),
              range: [0, 9],
              sort: (sort[0] === 'coverageDate' && sort) || [],
            });
            counts[type] = totalCount;
          } else {
            const params = { ...filters, status, recordTypeId };
            const { totalCount } = await this.recordManager.search({
              ...params,
              updatedAtMin: defaultUpdateAtMin(),
              range: [0, 0],
              mode: 'custom',
            });
            counts[type] = totalCount;
          }
        }),
      );
      dispatch(fetchRecordListCountSuccess(counts));
    } catch (e) {
      dispatch(fetchRecordListFailure(e.message));
    }
  };

  getBuyerOnGoingAppraisal = () => async (dispatch, getState) => {
    dispatch(fetchRecordListRequest());
    const state = getState();
    const range = getRange(state);
    try {
      const recordIds = await this.recordManager.allInRepoIds();
      const records = await Promise.all(
        recordIds
          .slice(range[0], range[1] + 1)
          .map(async (id) => RecordMapper.mapDetailToList(await this.recordManager.getRecordFromRepo(id))),
      );
      dispatch(fetchRecordListSuccess({ records, count: recordIds.length, type: 'buyerOnGoing' }));
    } catch (error) {
      dispatch(fetchRecordListFailure(error.message));
    }
  };

  fetchBuyerRecordForCurrentTab = () => async (dispatch, getState) => {
    const state = getState();
    let tab = getTab(state);
    const availableTabs = Object.keys(buyerTabs);
    if (!availableTabs.includes(tab)) {
      [tab] = availableTabs;
      dispatch(displayTab(tab));
    }
    const range = getRange(state);
    const userId = this.auth.userId();

    if (tab === 'buyerOnGoing') {
      await dispatch(this.getBuyerOnGoingAppraisal());
    } else {
      let sort = [];
      if (tab === 'buyerAwaitingPricing') {
        sort = ['expertiseEndedAt', 'ASC'];
      }
      dispatch(fetchRecordListRequest());
      const { status } = buyerTabs[tab];
      const filters = {
        status,
        range,
        userId,
        sort,
        ...(tab === 'buyerAwaitingForCounterAppraisal'
          ? { entryStockDateMin, entryStockDateMax }
          : { updatedAtMin: defaultUpdateAtMin() }),
      };
      try {
        const { records, totalCount } = await this.recordManager.search(filters);
        dispatch(
          fetchRecordListSuccess({
            records: records.map((r) => RecordMapper.mapRecordLists(r)),
            count: totalCount,
            type: tab,
          }),
        );
      } catch (error) {
        dispatch(fetchRecordListFailure(error.message));
      }
    }
  };

  refreshBuyerRecordsCount = () => async (dispatch) => {
    dispatch(fetchRecordListRequest());
    try {
      const counts = {};
      const userId = this.auth.userId();
      await Promise.all([
        ...Object.entries(buyerTabs).map(async ([type, { status }]) => {
          if (type === 'buyerOnGoing') {
            await this.syncManager.syncRecordWithInspectionInProgressInRepoOnly();
            counts[type] = (await this.recordManager.allInRepoIds()).length;
          } else {
            const { totalCount } = await this.recordManager.search({
              status,
              range: [0, 0],
              userId,
              mode: 'custom',
              ...(type === 'buyerAwaitingForCounterAppraisal'
                ? { entryStockDateMin, entryStockDateMax }
                : { updatedAtMin: defaultUpdateAtMin() }),
            });
            counts[type] = totalCount;
          }
        }),
      ]);
      dispatch(fetchRecordListCountSuccess(counts));
    } catch (e) {
      dispatch(fetchRecordListFailure(e.message));
    }
  };

  setSort = (sort) => async (dispatch) => {
    await dispatch(setSort(sort));
  };

  getUserFeeds = () => async (dispatch) => {
    try {
      const res = await this.recordManager.getUserFeeds();
      dispatch(fetchUserFeeds(res?.totalFeeds));
    } catch (e) {
      dispatch(fetchUserFeeds(0));
    }
  };

  fetchNrmRecordForCurrentTab = () => async (dispatch, getState) => {
    const state = getState();
    let tab = getTab(state);
    const availableTabs = Object.keys(nrmTabs);
    if (!availableTabs.includes(tab)) {
      [tab] = availableTabs;
      dispatch(displayTab(tab));
    }
    const range = getRange(state);
    dispatch(fetchRecordListRequest());
    const { status, nrmStatus, recordTypeId } = nrmTabs[tab];
    const filters = getFiltersNrm(state);
    const params = { ...filters, status, nrmStatus, recordTypeId };
    const sort = getSort(state);
    // if (tab === 'onGoingNrm') {
    //   sort = ['expertiseEndedAt', 'ASC'];
    // }
    try {
      let result = { records: [], totalCount: 0 };
      let datas = [];
      result = await this.recordManager.search({
        ...params,
        updatedAtMin: defaultUpdateAtMin(),
        range,
        sort,
        mode: 'nrm',
        ...(tab === 'waitingCounterInspectionNrm' && { useExpectedDeliveryDateForNrmAndNrmHbs: true }),
      });
      datas = result?.records.map((r) => RecordMapper.mapRecordLists(r));
      const { totalCount } = result;
      dispatch(fetchRecordListSuccess({ records: datas, count: totalCount, type: tab }));
    } catch (error) {
      dispatch(fetchRecordListFailure(error.message));
    }
  };

  refreshNrmRecordsCount = () => async (dispatch, getState) => {
    dispatch(fetchRecordListRequest());
    try {
      const counts = {};
      const state = getState();
      const filters = getFiltersNrm(state);
      await Promise.all(
        Object.entries(nrmTabs).map(async ([type, { status, nrmStatus, recordTypeId }]) => {
          const params = { ...filters, status, nrmStatus, recordTypeId };
          const { totalCount } = await this.recordManager.search({
            ...params,
            updatedAtMin: defaultUpdateAtMin(),
            range: [0, 0],
            mode: 'nrm',
            ...(getTab(state) === 'waitingCounterInspectionNrm' && { useExpectedDeliveryDateForNrmAndNrmHbs: true }),
          });
          counts[type] = totalCount;
        }),
      );
      dispatch(fetchRecordListCountSuccess(counts));
    } catch (e) {
      dispatch(fetchRecordListFailure(e.message));
    }
  };

  changePos = (pos) => async (dispatch) => {
    dispatch(changePos(pos));
  };
}
